import MsDyn365 from '@msdyn365-commerce/core';

export const setLocalStorage = (key: string, value: string) => {
    if (MsDyn365.isBrowser) {
        if (localStorage) {
            localStorage.setItem(key, value);
        }
    }
};

export const getLocalStorage = (key: string): string | undefined | null => {
    if (MsDyn365.isBrowser) {
        if (localStorage) {
            return localStorage.getItem(key);
        }
    }
    return undefined;
};
